var version = "10.2.5";

export { version as v };
//# sourceMappingURL=package-e24bf60a.js.map
